module.exports = __webpack_public_path__ + "img/9923.dc7494d4.jpg";